import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router> {/* Wrap App with Router */}
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Router>
);

reportWebVitals();